import React from "react";
import PickerList, { HasKeywordAndPagination, ModalPickerProps } from "./PickerList";
import MultiPickerSelectedItems from "./MultiPickerSelectedItems";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

type ModalPickerPropsWithoutOnItemSelected<T, TId extends number | string, TInstruction extends HasKeywordAndPagination> = Omit<ModalPickerProps<T, TId, TInstruction>, "onItemSelected">;

interface Props<T, TId extends number | string, TInstruction extends HasKeywordAndPagination> extends ModalPickerPropsWithoutOnItemSelected<T, TId, TInstruction> {
  value: T[]
  getLabel: (item: T) => string | JSX.Element
  onChange: (newValue: T[]) => void
  hideKeywordFilter?: boolean
}

const MultiPickerListWithSelectedItems = <T, TId extends number | string, TInstruction extends HasKeywordAndPagination>(props: React.PropsWithChildren<Props<T, TId, TInstruction>>) => {
  const { value, getLabel, onChange, ...rest } = props;

  const checkedSet = new Set(value.map(i => props.getId(i)));

  const onChecked = (item: T, checked: boolean) => {
    if (checked) {
      onChange([...value, item]);
    } else {
      onChange(value.filter(i => props.getId(i) !== props.getId(item)));
    }
  }
  return <>
    <MultiPickerSelectedItems
      selectedItems={value}
      onRemove={props.onChange}
      getId={props.getId}
      getLabel={getLabel}
    >
      <PickerList
        onItemSelected={item => onChecked(item, !checkedSet.has(props.getId(item)))}
        {...rest}
        renderListItem={item => (
          <div className="flex gap">
            <div>
              <Checkbox
                checked={checkedSet.has(props.getId(item))}
                onChange={(_, checked) => onChecked(item, checked)}
              />
            </div>
            <div>
              {rest.renderListItem(item)}
            </div>
          </div>
        )}
      />
    </MultiPickerSelectedItems>
  </>;
};

export default MultiPickerListWithSelectedItems;